import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/footer';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollTop from './components/scrolltop';
import AppRoutes from './routes/AppRoutes';

const App = () => {
  return (
    <Router>
      <ScrollToTopButton />
        <ScrollTop />
      <Header />
      <Navbar />
        <AppRoutes />
     
      <Footer />
    </Router>
  );
};

export default App;
 